import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import {
    DirectoryAccessService,
    DirectoryMenuModel,
    DirectoryModule,
} from '../../services/directory-access.service';
import { ImpersonationService } from '../../services/impersonation.service';
@Component({
    selector: 'menu-list',
    templateUrl: './menu-list.component.html',
    styleUrls: ['./menu-list.component.scss'],
})
export class MenuListComponent implements OnInit {
    @Input() navWidth: number;
    @Input() isMobile: boolean;
    @Output() hasItemClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
    menus: DirectoryMenuModel[];

    constructor(
        private router: Router,
        private directoryAccessService: DirectoryAccessService,
        private impersonationService: ImpersonationService
    ) {}

    ngOnInit() {
        this.checkForImpersonation();
        this.loadMenu();
    }

    loadMenu() {
        this.menus = [];
        this.directoryAccessService.getMenu().subscribe(
            (data) => {
                if (data) {
                    //remove subPages from settings so when user clicks settings icon, we just navigate there.
                    let settingsModule = data.modules.find(
                        (module) => module.page.module === 'settings'
                    );
                    if (settingsModule) {
                        settingsModule.subPages = [];
                    }
                    let directoryModule = data.modules.find(
                        (module) => module.page.module === 'directory'
                    );
                    if (directoryModule) {
                        directoryModule.subPages = [];
                    }
                    this.menus = data.modules;

                    // Determine which menu item will have a divider before settings, directory, reports
                    let skip = false;

                    if (this.menus.length === 1) {
                        this.menus[0].page.hasDivider = false;
                    } else {
                        for (let i = 0; i < this.menus.length; i++) {
                            this.menus[i].page.hasDivider = false;

                            if (skip == false) {
                                if (
                                    this.menus[i].subPages == null ||
                                    this.menus[i].subPages.length === 0 ||
                                    this.menus[i].page.module === 'my-vision'
                                ) {
                                    this.menus[i - 1].page.hasDivider = true;
                                    skip = true;
                                }
                            }
                        }
                    }
                } else {
                    this.menus = [];
                }
            },
            (error) => {
                this.menus = [];
                throw new Error(error);
            }
        );
    }

    setWidth(navWidth: number) {
        this.navWidth = navWidth;
    }

    accordianMenuOpenClose(section: DirectoryMenuModel) {
        this.exitOtherSections(section);
        section.page.expanded = !section.page.expanded;
    }

    navigateTo(section: DirectoryMenuModel) {
        if (section.subPages.length === 0) {
            this.router.navigate([section.page.routerURL]);
            this.hasItemClicked.emit(true);
        }
    }

    exitOtherSections(section: DirectoryMenuModel) {
        let otherSections = this.menus.filter((item) => item.page.module !== section.page.module);
        otherSections.forEach((item) => {
            item.page.expanded = false;
        });
    }

    mobileMenuClicked(section: DirectoryMenuModel) {
        section.page.expanded = false;
        this.hasItemClicked.emit(true);
    }

    closeFlyout(section: DirectoryMenuModel) {
        section.page.expanded = false;
    }

    onSectionSelected(section: DirectoryMenuModel, subSection?: DirectoryModule) {
        if (!this.isMobile) {
            this.exitAllSections();
            section.page.expanded = !section.page.expanded;
        }
    }

    getActiveClass(module: string, routerURL: string): string {
        if (this.router.url.includes('/reporting/')) {
            return 'reports-active';
        } else if (this.router.isActive(routerURL, false)) return '' + module + '-active';
        else return '';
    }

    @HostListener('document:keydown.escape', ['$event'])
    onKeydownHandler(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.exitAllSections();
            this.menus
                .filter((menu) => menu.page.expanded)
                .forEach((menu) => (menu.page.expanded = !menu.page.expanded));
        }
    }

    mouseEnter(section: DirectoryMenuModel) {
        section.page.expanded = true;
    }

    mouseLeave(section: DirectoryMenuModel) {
        section.page.expanded = false;
    }

    exitAllSections() {
        for (var i = 0; i < this.menus.length; i++) {
            this.menus[i].page.expanded = false;
        }
    }

    // Subscribes to router events to watch for initiations of impersonation.
    // If there is an impersonation session has begun, the navigation pane (menu list) will reload.
    checkForImpersonation() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                let isImpersonating = this.impersonationService.isImpersonating;

                // If URL is at root (signifying impersonation could have been initiated)
                // and the user is impersonating
                if (event.url == '/' && isImpersonating) {
                    this.loadMenu(); // Reload the navigation menu to renew locks
                }
            }
        });
    }
}
